import InfiniteLoader from '~/components/GraphInfiniteLoader';
import Select from '~/components/Select';
import { SidebarContent } from '~/components/Sidebar';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '~/components/Table';

import styles from './EventsList.style';
import ListEventsItem from './EventsListItem';

class EventsList extends React.Component {
  constructor(props) {
    super(props);

    this.list = React.createRef();

    this.state = {
      expandedRows: {},
    };
  }

  toggleListItem = (index) => {
    this.setState(
      (prevState) => ({
        expandedRows: {
          ...prevState.expandedRows,
          [index]: !prevState.expandedRows[index],
        },
      }),
      () => {
        this.list.current.resetAfterIndex(index, true);
      },
    );
  };

  rowExpanded = (index) => !!this.state.expandedRows[index];

  getRowHeight = (index) => (this.rowExpanded(index) ? 400 : 58);

  render() {
    const {
      classes,
      events,
      hasNextPage,
      eventTypes,
      onFilter,
      onLoadMore,
      loading,
      loadingMore,
      type,
    } = this.props;

    return (
      <div className={classes.root}>
        <SidebarContent>
          <div className={classes.header}>
            <Select
              options={eventTypes}
              getOptionValue={(option) => option}
              getOptionLabel={(option) => option}
              placeholder="Filter by event type"
              className={classes.filter}
              onChange={onFilter}
              isDisabled={loading}
              value={[type]}
            />
          </div>
          <Table sidebar>
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>Timestamp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <InfiniteLoader
                dynamicHeight
                hasNextPage={hasNextPage}
                listRef={this.list}
                loading={loading}
                loadingMore={loadingMore}
                nodes={events}
                onLoadMore={onLoadMore}
                rowHeight={(index) => this.getRowHeight(index)}
                rowRenderer={(event, index, style) => (
                  <div
                    key={event.id}
                    role="listitem"
                    onClick={() => this.toggleListItem(index)}
                    style={style}>
                    <ListEventsItem
                      event={event}
                      index={index}
                      expanded={this.rowExpanded(index)}
                    />
                  </div>
                )}
              />
            </TableBody>
          </Table>
        </SidebarContent>
      </div>
    );
  }
}

EventsList.defaultProps = {
  events: {
    pageInfo: {
      hasNextPage: false,
    },
  },
};

EventsList.propTypes = {
  id: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  events: PropTypes.array.isRequired,
  eventTypes: PropTypes.array.isRequired,
  onFilter: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  loadingMore: PropTypes.bool,
  type: PropTypes.string,
  hasNextPage: PropTypes.bool,
};

export default withStyles(styles)(EventsList);
